import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export async function getErrorMessage(response: Response, defaultMessage: string = "An error occurred"): Promise<string> {
  try {
    const errorText = await response.text();
    try {
      const errorData = JSON.parse(errorText);
      return errorData.message || defaultMessage;
    } catch {
      return errorText || defaultMessage;
    }
  } catch {
    return defaultMessage;
  }
}
